/**
 * Какие карточки есть на дашборде.
 *
 * Карточка — это инструмент расчёта. Все читают одно состояние фильтров и
 * грузятся независимо: смена фильтра запускает до восьми агрегатов, и самая
 * медленная не должна держать экран.
 */

export type PanelKind = "tiles" | "series" | "topVideos" | "people" | "compare" | "growth";

export type ToolSpec = {
  key: string;
  title: string;
  hint: string;
  kind: PanelKind;
  /** Широкая карточка занимает всю строку сетки. */
  wide?: boolean;
};

export const TOOLS: ToolSpec[] = [
  {
    key: "timeseries",
    title: "Динамика",
    hint: "Как менялась метрика по интервалам периода",
    kind: "series",
    wide: true,
  },
  {
    key: "count_episodes",
    title: "Выпуски",
    hint: "Сколько выпусков вышло — по дате публикации",
    kind: "tiles",
  },
  {
    key: "sum_metric",
    title: "Сумма метрики",
    hint: "Сколько набрано за период — по дате накопления",
    kind: "tiles",
  },
  {
    key: "program_stats",
    title: "Сводка по программе",
    hint: "Выпуски, просмотры, подписки, доход",
    kind: "tiles",
  },
  {
    key: "top_videos",
    title: "Топ выпусков",
    hint: "Лучшие выпуски по выбранной метрике",
    kind: "topVideos",
    wide: true,
  },
  {
    key: "people_summary",
    title: "Люди",
    hint: "Кто сколько провёл выпусков",
    kind: "people",
  },
  {
    key: "compare_people",
    title: "Сравнение людей",
    hint: "Двое по средней метрике на выпуск",
    kind: "compare",
  },
  {
    key: "compare_growth",
    title: "Рост против канала",
    hint: "Две половины периода: программа и канал",
    kind: "growth",
  },
];
